import type { Common } from '@libs/domain';

export class JobComment implements Pick<Common['schema'], 'jobComment'> {
  /**
   * @param jobComment コメント
   */
  private constructor(readonly jobComment: string) {}

  static init() {
    return new JobComment('');
  }
}
